<template>
  <div class="main">
    <!-- 6bab91 -->
    <div>
      <div class="title">2023上海市职工智能体质监测团体达标赛 徐汇区分站赛</div>
      <div class="row">
        <div class="rank">
          <div class="t-title" :style="`color: #${this.$route.query.color ? 'fff' : ''};`">体测监测团体达标赛</div>
          <div class="rank-area rank1">
            <div class="thead">
              <span class="num">名次</span>
              <span class="team">团队名</span>
              <span class="first">初测总成绩</span>
              <span class="second">复测总成绩</span>
              <span class="lap">体质提升值</span>
            </div>
            <div class="tbody">
              <transition-group name="list" tag="ul">
                <li class="t-item" v-for="row in team1" :key="row.id">
                  <span class="num">{{ row.rank }}</span>
                  <span class="team">{{ row.name }}</span>
                  <span class="first">{{ row.score1 }}</span>
                  <span class="second">{{ row.score2 }}</span>
                  <span class="lap">{{ row.pect }}</span>
                </li>
              </transition-group>
            </div>
          </div>
        </div>
        <div class="rank">
          <div class="t-title" :style="`color: #${this.$route.query.color ? 'fff' : ''};`">AR趣味健身</div>
          <div class="rank-area rank2">
            <div class="thead">
              <span class="num">名次</span>
              <span class="team">团队名</span>
              <span class="lap">团队成绩</span>
            </div>
            <div class="tbody">
              <transition-group name="list" tag="ul">
                <li class="t-item" v-for="row in team2" :key="row.groupName">
                  <span class="num">{{ row.rank }}</span>
                  <span class="team">{{ row.groupName }}</span>
                  <span class="lap">{{ row.groupScore }}</span>
                </li>
              </transition-group>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'

export default {
  data() {
    return {
      team1: [],
      team2: [],
      matchid: this.$route.query.matchid,
      trackid: this.$route.query.trackid,
      limit: 10,
      time: 10,
      title: '',
      current: {},
    }
  },
  mounted() {
    this.limit = this.$route.query.limit || 10
    this.time = this.$route.query.time || 10
    this.read_team1()
    this.read_team2()
  },
  methods: {
    read_team1() {
      api.user
        .getYizhanRank({
          type: 3,
          stid: 31,
          app: 20,
          gid: 'eStBcUhqZ0ZvRE09',
          urid: 1178,
          token: 'jnCLhApOf4xV69e64tgyF6MWLyM5OWzu_1658481568',
        })
        .then((r) => {
          let list = r.data.list
          let i = 0
          let team1 = list.slice(i, i + this.limit * 1)
          team1.forEach((row) => {
            row.rank = i + 1
            i++
          })
          this.team1 = []
          setTimeout(() => {
            let j = 0
            let timer6 = setInterval(() => {
              if (j >= team1.length) {
                clearInterval(timer6)
                return
              }
              this.team1.push(team1[j])
              j++
            }, 100)
          }, 400)
          let timer1 = setInterval(() => {
            if (i >= list.length) {
              clearInterval(timer1)

              this.read_team1()
              return
            }
            let team1 = list.slice(i, i + this.limit * 1)
            team1.forEach((row) => {
              row.rank = i + 1
              i++
            })
            this.team1 = []
            setTimeout(() => {
              let j = 0
              let timer2 = setInterval(() => {
                if (j >= team1.length) {
                  clearInterval(timer2)
                  return
                }
                this.team1.push(team1[j])
                j++
              }, 100)
            }, 400)
          }, this.time * 1000)
        })
    },
    read_team2() {
      api.user
        .getArRank({
          gid: 'eStBcUhqZ0ZvRE09',
          urid: 1178,
          matchid: 9948,
          token: 'jnCLhApOf4xV69e64tgyF6MWLyM5OWzu_1658481568',
        })
        .then((r) => {
          let list = r.data
          let i = 0
          let team2 = list.slice(i, i + this.limit * 1)
          team2.forEach((row) => {
            row.rank = i + 1
            i++
          })
          this.team2 = []
          setTimeout(() => {
            let j = 0
            let timer5 = setInterval(() => {
              if (j >= team2.length) {
                clearInterval(timer5)
                return
              }
              this.team2.push(team2[j])
              j++
            }, 100)
          }, 400)
          let timer3 = setInterval(() => {
            if (i >= list.length) {
              clearInterval(timer3)
              this.read_team2()
              return
            }
            let team2 = list.slice(i, i + this.limit * 1)
            team2.forEach((row) => {
              row.rank = i + 1
              i++
            })
            this.team2 = []
            setTimeout(() => {
              let j = 0
              let timer4 = setInterval(() => {
                if (j >= team2.length) {
                  clearInterval(timer4)
                  return
                }
                this.team2.push(team2[j])
                j++
              }, 100)
            }, 400)
          }, this.time * 1000)
        })
    },
  },
}
</script>

<style lang="less" scoped>
.main {
  height: 100vh;
  width: 100vw;
  display: flex;
  justify-content: center;
  padding: 20px 40px 0;
  background: url(https://oss.mcloud.moveclub.cn/mcloudbkh5/20230209/1675942652-63e4dafc1c40a.png) no-repeat center center / cover;
  > div {
    width: 100%;
  }

  .title {
    font-size: 48px;
    text-align: center;
    width: 100%;
    padding: 46px 0 58px;
    color: #fff;
  }

  .row {
    display: flex;
    align-items: center;
    justify-content: space-between;
    .rank {
      width: 908px;
      height: 828px;
      background: #ffffff;
      border-radius: 18px;
      overflow: hidden;
    }
  }
  .t-title {
    font-size: 28px;
    font-weight: bold;
    width: 100%;
    text-align: center;
    padding: 16px 0 20px;
  }

  .rank-area {
    font-size: 22px;

    .thead {
      width: 100%;
      background: #ffffffda;
      padding: 8px;

      span {
        font-weight: bold;
      }
    }

    span {
      padding: 4px;
      display: inline-block;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
    }

    &.rank1 {
      .num {
        width: 10%;
        text-align: center;
      }

      .team {
        width: 40%;
      }
      .first,
      .second {
        width: 15%;
      }
      .lap {
        width: 20%;
      }
    }
    &.rank2 {
      .num {
        width: 10%;
        text-align: center;
      }

      .team {
        width: 60%;
      }
      .lap {
        width: 30%;
      }
    }

    ul {
      margin: 0;
      padding: 0;
      perspective: -300;
      transform-style: preserve-3d;
      li {
        list-style: none;
        margin: 1px 0;
        background: rgba(255, 255, 255, 0.4);
        padding: 8px 0;
      }
    }
  }
}
</style>

<style scoped>
.rank >>> .ant-table {
  font-size: 20px;
  background: #fff;
}

.list-enter-active {
  transition: all 1s;
  transform-origin: top;
}

.list-leave-active {
  transition: all 0.4s;
  transform-origin: bottom;
}

.list-enter {
  opacity: 0;
  transform: rotateX(90deg);
}

.list-leave-to {
  opacity: 0;
  transform: rotateX(90deg);
}
</style>
